module.exports = __webpack_public_path__ + "img/box-arrow-in-left.1613fbf4.svg";